export const COOKIE_STORAGE = 'cookies_accepted';
export const LAST_REFRESH_STORAGE = 'last_refresh';
export const LOCAL_PRODUCT_STORAGE = 'local_product';
export const TUTORIAL_STORAGE = 'show_tutorials';
